import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import CommonFunc from "./common";
import Path from "./const/path";
import { useLocation } from "react-router-dom";
import memberContext from "../../store/Member";
import CommonContext from "../../store/Common";
import CommonAPI from "../../API/common";

function readServiceFlag(commonValue, storageKey) {
  if (commonValue != null) return String(commonValue);
  return sessionStorage.getItem(storageKey);
}

/** 기업 유형: 2 = 출연연 */
function isResearchInstituteOrg(commonValue, memberValue) {
  const raw =
    commonValue ??
    memberValue ??
    sessionStorage.getItem("organization_type");
  return String(raw) === "2";
}

function IntroMenu({ headHide, activeTab, auth, location, isExceptionURL }) {
  const member = useContext(memberContext);
  const isLogin = Boolean(member.idx);
  const common = useContext(CommonContext);
  const memberAuth = auth ?? member.auth;
  const isInventor = window.$Global.checkAuth("특허회사_발명자만", memberAuth);
  const isStatisticPath = readServiceFlag(
    common.statistics_service,
    "statistics_service"
  );
  const isSimpleStatisticPath = readServiceFlag(
    common.simple_statistics_service,
    "simple_statistics_service"
  );
  const isTransferStatisticPath = readServiceFlag(
    common.transfer_statistics_service,
    "transfer_statistics_service"
  );
  // 연차료관리 메뉴: 명시적 false일 때만 숨김 (미설정 시 표시)
  const isAnnualPayPath = readServiceFlag(
    common.annual_pay_service,
    "annual_pay_service"
  );
  const showInventionReview = isResearchInstituteOrg(
    common.organization_type,
    member.organization_type
  );
  const isAgent = sessionStorage.getItem("is_agent"); // 대리인 여부 판별
  const redirect = () => {
    window.$Global.redirectHome(auth);
  };

  const onClickChangeView = () => {
    window.$Global.toggleViewType();
  };

  const [companyLogo, setCompanyLogo] = useState(null);
  const qs = new URLSearchParams(location.search);
  const code = qs.get("code");

  useEffect(() => {
    if (code && !isLogin) {
      CommonAPI.getCompanyCode(code).then((res) => {
        setCompanyLogo(res.data);
      });
    }
  }, [code]);

  // rank 2(발명자): 특허통계·심플통계·기술이전관리 비노출
  const path = isInventor
    ? Path.buildInventorMenus({ showInventionReview })
    : Path.buildCompanyMenus({
        hideAnnual: isAnnualPayPath === "false",
        showInventionReview,
        statistic: isStatisticPath,
        simple: isSimpleStatisticPath,
        transfer: isTransferStatisticPath,
      });

  return (
    <div id="IntroMenu">
      {!headHide && !isExceptionURL && (
        <div className="intro_link">
          <img
            src={
              companyLogo
                ? window.$Global.getCDN(companyLogo.image_key)
                : require("../../assets/images/common/logo_ipnow.svg").default
            }
            style={{ width: 120, height: 70, objectFit: "contain" }}
            onClick={redirect}
            alt="이미지"
          />
          {!auth && (
            <div className="sign">
              <Link className="btn_login" to="/login">
                로그인
              </Link>
              <Link
                className="btn_signup"
                to="/signup/type"
                style={{
                  background: "linear-gradient(to right, #ff7a00 32%, #ffa600)",
                }}
              >
                무료 회원가입
              </Link>
            </div>
          )}
        </div>
      )}
      <div className={isLogin ? "tab_list_wrapper_login" : "tab_list_wrapper"}>
        <ul className={isLogin ? "tab_list service_tab_list" : "tab_list"}>
          {CommonFunc.DrawTab(
            isLogin ? path : Path.match_ip_service,
            activeTab,
            "bold",
            isLogin
          )}
        </ul>
        {!isLogin && (
          <div className="tab_list_service">
            <Link
              to="/intro/service/detail"
              className={
                location.pathname === "/intro/service/detail" && "active"
              }
            >
              서비스 소개
            </Link>
            <h2>|</h2>
            <Link
              to="/intro/service"
              className={location.pathname === "/intro/service" && "active"}
            >
              Q&A
            </Link>
            <h2>|</h2>
            <button
              className="btn_change btn_findbiz"
              onClick={onClickChangeView}
            >
              <p>
                <span>비즈내비</span>&nbsp;바로가기&nbsp;&gt;
              </p>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default IntroMenu;
